var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26,
    fill: "none",
    viewBox: "0 0 30 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.667 18.333c2.577 0 4.666-3.88 4.666-8.666S26.244 1 23.667 1m0 17.333c-2.578 0-4.667-3.88-4.667-8.666S21.09 1 23.667 1m0 17.333L6.258 15.168c-1.237-.225-1.855-.337-2.355-.583a4 4 0 0 1-2.084-2.497c-.152-.536-.152-1.164-.152-2.421s0-1.886.152-2.422a4 4 0 0 1 2.084-2.497c.5-.246 1.118-.358 2.355-.583L23.667 1m-18 14.667.525 7.352c.05.698.075 1.047.226 1.312.134.232.335.42.577.536C7.27 25 7.62 25 8.32 25h2.376c.8 0 1.2 0 1.497-.16.26-.14.466-.363.586-.633.136-.307.106-.706.044-1.504l-.49-6.37"
  })));
};
export default SvgAlarm;